import { useQueryGetProject } from '../../../../../core/queries/projects.queries';
import { getBookingFlowType, isInventoryFlow, isRetailFlow } from '../../../../../core/util/booking-flow-type.util';
import { BookingFlowType } from '../../../../../ui/enums/booking-flow-type.enum';

export function useBookingFlowType(projectId: string): BookingFlowType {
  const project = useQueryGetProject(projectId);
  return getBookingFlowType(project.data);
}

export function useIsInventoryFlow(projectId: string): boolean {
  const project = useQueryGetProject(projectId);
  return isInventoryFlow(project.data);
}

export function useIsRetailFlow(projectId: string): boolean {
  const project = useQueryGetProject(projectId);
  return isRetailFlow(project.data);
}
